<div
  class="item-content"
  (click)="$event.stopPropagation()"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="!data.isReadOnly ? menu : null"
  >
  @if (view === 'month') {
    <div
      class="month-item"
      [ngClass]="{
        'read-only-card': data.isReadOnly,
        'pending-contact': applyPendingContactStyle(data)
      }"
      >
      <span class="dot" [style.background-color]="statusSelectedColor"></span>
      <div class="month-item__body">
        <div class="month-item__title">
          <label class="truncate">{{ data.clientCity }}</label>
          @if (data.isPromotional) {
            <img
              class="month-item__promo"
              src="../assets/icons/promotional-icon/promotional-icon.png"
              alt=""
              />
          }
        </div>
        <span class="item-product-alias">
          @if (
            (data.jobGroup == 'Instalar' && data.taskType == 'Piscina') ||
            data.taskType == 'Piscina y Equipamiento'
            ) {
            @if (!data.isPaidLabor && data.paidLaborAboutToExpire) {
              <img
                class="check-paid-labor"
                src="../../../../../assets/icons/common/paycheck-red.svg"
                />
            }
            @if (!data.isPaidLabor && !data.paidLaborAboutToExpire) {
              <img
                class="check-paid-labor"
                src="../../../../../assets/icons/common/paycheck-grey.svg"
                />
            }
            @if (data.isPaidLabor) {
              <img
                class="check-paid-labor"
                src="../../../../../assets/icons/common/paycheck-green.svg"
                />
            }
          }
          @if (data.isReadOnly) {
            <span class="item-product-alias__text" style="font-weight: bold">{{
              data.schudeledDate | date : "hh:mm a"
            }}</span>
          }
          @if (!data.isReadOnly) {
            <span class="item-product-alias__text">{{ data.productAlias }}</span>
          }
        </span>
        @if (data.isReadOnly) {
          <span class="read-only-message">Ocupado</span>
        }
      </div>
      @if (
        data.taskType == 'Piscina' ||
        data.taskType == 'Piscina y Equipamiento'
        ) {
        <span
          class="stream"
          [style.background-color]="getPoolColor(data.productColorName)"
        ></span>
      }
    </div>
  }
    @if (view != 'month') {
      <div class="week-item" [style.height.px]="height">
        <div [style.background-color]="statusSelectedColor" class="actveBorder"></div>
        <div
          class="day-event-box"
          [style.background-color]="!data.isReadOnly ? statusColor : null"
          [ngClass]="data.isReadOnly ? 'read-only-card' : ''"
          (click)="eventClicked.emit({ event: events })"
          >
          <label class="truncate" [title]="data.jobGroup + ' ' + data.taskType"
            >{{ data.jobGroup }} {{ data.taskType }}</label
            >
          @if (data.isReadOnly && view != 'week') {
            <span class="read-only-message">Ocupado</span>
          }
        </div>
      </div>
    }
      </div>

      <mat-menu #menu="matMenu" class="details-popover">
        <mat-card appearance="outlined">
          <div class="summary-popover">
            <mat-card-header class="popover-header">
              <div class="row w-100">
                <div class="col-7">
                  <div class="popover-header-title">
                    <label class="popover-title">
                      <span class="third-party-app">
                        {{ getThirdPartyAppName(data.fromThirdPartyApp) }}
                      </span>
                      @if (data.fromMobile) {
                        <img
                          src="/assets/icons/common/mobile.svg"
                          alt=""
                          />
                      }
                      {{ data.jobGroup }} {{ data.taskType }}
                      @if (data.isPromotional) {
                        <img
                          class="mb-1"
                          src="../assets/icons/promotional-icon/promotional-icon.png"
                          alt=""
                          />
                      }
                    </label>
                  </div>
                </div>
                <div class="col-5">
                  <div
                    class="popover-header-status"
                    [style.color]="statusSelectedColor"
                    [style.background-color]="statusColor"
                    >
                    <span>{{ statusDescription }}</span>
                  </div>
                </div>
              </div>
            </mat-card-header>
            <mat-card-content class="popover-content">
              <div class="row">
                <div class="col-6">
                  <div class="row pt-2" class="value">Horario</div>
                  <div class="row pb-3">
                    <span style="font-weight: bold">{{
                      data.schudeledDate | date : "hh:mm a"
                    }}</span>
                  </div>
                  <div class="row" class="value">Domicilio</div>
                  <div class="row mb-2">
                    <span style="font-weight: bold">{{ data.clientAddress }}</span>
                  </div>
                  <div class="row pt-2" class="value">Prestador</div>
                  <div class="row pb-3">
                    <span style="font-weight: bold">{{ data.contractorName }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row pt-2" class="value">Cliente</div>
                  <div class="row mb-2">
                    <span style="font-weight: bold">{{ data.clientName }}</span>
                  </div>
                  <div class="row pt-2" class="value">Teléfono</div>
                  <div class="row mb-2">
                    <span style="font-weight: bold"
                      >{{ data.clientPhone ?? "-" }}
                      @if (data.clientPhone) {
                        <a
                  href="https://wa.me/{{
                    data.clientPhone?.replace('-', '') ?? '-'
                  }}"
                          target="_blank"
                          title="Enviar mensaje a {{ data.clientName }}"
                          >
                          <div class="wpp-button">
                            <img
                              src="assets/icons/common/whatsapp.svg"
                              alt="WhatsApp"
                              />
                            </div>
                          </a>
                        }
                      </span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
              <mat-card-actions align="end" class="popover-action">
                <div class="pr-2">
                  <button
                    mat-button
                    class="ind-btn-grey ind-btn-primary"
                    (click)="menuTrigger.closeMenu()"
                    >
                    Cerrar
                  </button>
                  <button mat-button class="ind-btn-base" (click)="dialogAction()">
                    <span class="detail-color">Ver detalle</span>
                  </button>
                </div>
              </mat-card-actions>
            </div>
          </mat-card>
        </mat-menu>
